<template>
  <TopBar />
  <SideBar v-if="state.status == 1" />
  <div class="toolbar">
    <ToolBar :reportName="state.name" />
  </div>
  <div>
    <ReportPage :link="state.link" :name="state.name" />
  </div>
</template>

<script setup lang="ts">
import TopBar from "@/components/topbar/TopBar.vue";
import SideBar from "@/components/SideBar.vue";
import ToolBar from "@/components/toolbar/ToolBar.vue";
import ReportPage from "@/components/report/ReportPage.vue";
import { useAuthenticationStore, LogStatus } from "@/stores/authentication";
import { useEmbedStore } from "@/stores/embedStore";
import { onMounted, ref } from "vue";

const state = ref({
  status: 0, // 0 - loading, 1 - logged in, -1 - not logged in
  link: "",
  name: "",
});

onMounted(async () => {
  const Authorization = useAuthenticationStore();
  loggedCheck(Authorization.getLoggedStatus());
  state.value.status = 0;
  await Authorization.login();
  if (Authorization.getLoggedStatus() == LogStatus.Logged) {
    state.value.status = 1;
    loggedCheck(Authorization.getLoggedStatus());
  } else {
    state.value.status = -1;
  }

  const embedStore = useEmbedStore();
  // get parameters from url and load report data
  const urlParams = new URLSearchParams(window.location.search);
  const url = urlParams.get("url") ?? "";
  await embedStore.loadReportData(url);
  state.value.link = embedStore.getReportLink();
  state.value.name = embedStore.getReportName();
});

function loggedCheck(value: LogStatus) {
  if (value == LogStatus.Logged) {
    sessionStorage.getItem("log_to") ?? "/";
    sessionStorage.removeItem("log_to");
  }
}
</script>

<style lang="scss">
@use "assets/scss/personPhoto.scss";
@use "assets/scss/common.scss";

.toolbar {
  display: flex;
  align-items: center;
  width: 100%;
}

body {
  height: 100%;
  margin: 0;
  font-family: ABBVoice, Verdana, Arial, sans-serif;
  background-color: #e6e6e6 !important;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 35px 12px 0 60px;
}

.row.short-gutters {
  margin-right: -7px;
  margin-left: -7px;
}

.short-gutters > .col,
.short-gutters > [class*="col-"] {
  padding-right: 7px;
  padding-left: 7px;
}

.vertical-gutters > .col,
.vertical-gutters > [class*="col-"] {
  padding-top: 7px;
  padding-bottom: 7px;
}

.vertical-gutters-top > .col,
.vertical-gutters-top > [class*="col-"] {
  padding-bottom: 7px;
}
</style>
